import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useErrorBannerStore, clearError } from '../lib/errorBanner';

export function ErrorBanner() {
	const current = useErrorBannerStore((s) => s.current);
	if (!current) return null;

	return (
		<Box
			role="alert"
			sx={{
				position: 'fixed',
				top: 0,
				left: 0,
				right: 0,
				zIndex: 10000,
				bgcolor: '#fff1f0',
				borderBottom: '1px solid #fca5a5',
				color: '#7f1d1d',
				boxShadow: '0 2px 6px rgba(127,29,29,0.18)',
			}}
		>
			<Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, px: 2, py: 1.25, maxWidth: 1200, mx: 'auto' }}>
				<Box sx={{ flex: 1, minWidth: 0 }}>
					<Box sx={{ fontWeight: 700, fontSize: 14 }}>{current.title}</Box>
					<Box sx={{ fontSize: 13, mt: '2px' }}>{current.summary}</Box>
					{current.details?.map((g, gi) => (
						<details key={gi} open style={{ marginTop: 6, fontSize: 12 }}>
							<summary style={{ cursor: 'pointer', fontWeight: 600, color: '#991b1b' }}>{g.label}</summary>
							<Box component="ul" sx={{ m: '4px 0 0 0', pl: 2.25, maxHeight: 240, overflowY: 'auto' }}>
								{g.rows.map((r, ri) => (
									<Box component="li" key={ri} sx={{ display: 'flex', gap: 1, alignItems: 'baseline', py: '2px' }}>
										{r.row != null && (
											<span style={{ fontFamily: 'ui-monospace, Menlo, Consolas, monospace', color: '#6b7280', fontSize: 11, minWidth: 56 }}>
												Row {r.row}
											</span>
										)}
										{r.qr && (
											<span style={{ fontFamily: 'ui-monospace, Menlo, Consolas, monospace', color: '#1f2937', minWidth: 80 }}>{r.qr}</span>
										)}
										<span style={{ flex: 1 }}>{r.reason}</span>
									</Box>
								))}
							</Box>
						</details>
					))}
				</Box>
				<IconButton size="small" aria-label="Dismiss" onClick={clearError} sx={{ color: '#7f1d1d' }}>
					<CloseIcon fontSize="small" />
				</IconButton>
			</Box>
		</Box>
	);
}
